import wixData from 'wix-data';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

let isMobile = wixWindow.formFactor === "Mobile";

const buttons = {
	'ContentManagement': '#ContentManagementBox',
	'DesignFunctionality': '#DesignFunctionalityBox',
	'APIsDevelopmentTools': '#APIsDevelopmentToolsBox'
};

let menuObjectAsArray;

$w.onReady(() => {
	if (isMobile) {
		$w("#textGoToEditor1").html = `<p style="font-size: 1.3em;  font-face: helvetica; color: #636363; line-height: 1.7em; text-align: center"><span style="font-weight: bolder"> To start using Velo: <br></span> <span>Go to the Wix Editor from your desktop > <br>Velo > Enable Velo</span></p>`
	}

	menuObjectAsArray = Object.keys(buttons);
	initNextPreviousButtons();

	if (isMobile) {
		$w("#ContentManagementBox").style.borderColor = "#fff";
		$w("#DesignFunctionalityBox").style.borderColor = "#fff";
		$w("#APIsDevelopmentToolsBox").style.borderColor = "#fff";

	} else {

		$w("#ContentManagementBox").style.borderColor = "#BEBEBE";
		$w("#DesignFunctionalityBox").style.borderColor = "#BEBEBE";
		$w("#APIsDevelopmentToolsBox").style.borderColor = "#BEBEBE";

	}
});

function loadDefaultVideos() {
	let categoryVideoGallery;
	for (let i = 0; i < menuObjectAsArray.length; i++) {
		categoryVideoGallery = `${menuObjectAsArray[i]}Videos`
		loadVideo($w(`#${categoryVideoGallery}`).items[0].description, categoryVideoGallery)
	}
}

function initNextPreviousButtons() {
	for (let i = 0; i < menuObjectAsArray.length; i++) {
		$w(`#${menuObjectAsArray[i]}GalleryNext`).onClick(() => {
			$w(`#${menuObjectAsArray[i]}Videos`).next()
		})
		$w(`#${menuObjectAsArray[i]}GalleryPrevious`).onClick(() => {
			$w(`#${menuObjectAsArray[i]}Videos`).previous()
		})
	}
}

function enableAllMenuButtons() {
	for (let i = 0; i < menuObjectAsArray.length; i++) {
		$w(`#${menuObjectAsArray[i]}`).enable()
	}
}

function loadVideo(videoId, category) {
	//wixData.query("Tutorials").eq('_id', videoId).include('demonstrates').find().then((results) => {
	wixData.query("Tutorials").eq('_id', videoId).find().then((results) => {
		let video = results.items[0]
		$w(`#${category}Player`).src = video.url;
		$w(`#${category}Title`).text = video.title;
		$w(`#${category}Description`).text = video.description
		// if (video.demonstrates.length > 0) {
			
		// 	$w(`#${category}ExampleDemonstrates`).expand();
		// 	$w(`#${category}Repeater`).expand()
		// 	$w(`#${category}Repeater`).data = video.demonstrates
		// } else {
		// 	$w(`#${category}ExampleDemonstrates`).collapse();
		// 	$w(`#${category}Repeater`).collapse()
		// }
	})
}

export function pickVideo(event) {
	loadVideo(event.item.description, event.target.id)
}

export function menuButtonClick(event) {
	let buttonClicked = event.target.id
	enableAllMenuButtons();
	$w(`${buttons[buttonClicked]}`).scrollTo()
	$w(`#${buttonClicked}`).disable()
}

export function boxSmallMenu_viewportEnter(event) {
	enableAllMenuButtons();
}

export function APIsDevelopmentToolsVideosRepeater_itemReady($item, itemData, index) {
	$item("#APIsDevelopmentToolsVideosExampleItem").text = itemData.title
}

export function DesignFunctionalityVideosRepeater_itemReady($item, itemData, index) {
	$item("#DesignFunctionalityVideosExampleItem").text = itemData.title
}

export function ContentManagementVideosRepeater_itemReady($item, itemData, index) {
	$item("#ContentManagementVideosExampleItem").text = itemData.title
}

let datasetReady = 0;

export function waitForDataset() {
	datasetReady++
	if (datasetReady === 3) {
		loadDefaultVideos();
	}
}

export function gettingStartedBox_viewportEnter(event) {
	if (!isMobile) {
		$w("#boxBackToTop").hide()
	}
}

export function gettingStartedBox_viewportLeave(event) {
	if (!isMobile) {
		$w("#boxBackToTop").show()
	}
}

export function boxBackToTop_click(event) {
	$w("#anchorTop").scrollTo();
}